module.exports = __webpack_public_path__ + "img/9788952778468.45becb9b.jpg";